import { render, staticRenderFns } from "./Screenshot.vue?vue&type=template&id=d541777c&scoped=true"
import script from "./Screenshot.vue?vue&type=script&setup=true&lang=js"
export * from "./Screenshot.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Screenshot.vue?vue&type=style&index=0&id=d541777c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d541777c",
  null
  
)

export default component.exports